import { api } from "../api";

export const getProductsList = (brandId, token) => {
  return new Promise((resolve, reject) => {
    api.products
      .getProducts({ brandId }, token)
      .then((res) => {
        let parsedResult = [];
        if (res.code === 200 && res.data.result) {
          res.data.result.forEach((brand) => {
            // Use forEach instead of map
            parsedResult.push({
              margin: brand.productMargin,
              value: brand.productId,
              label: `${brand.productName} (Available stock Qty - ${brand.stockAvailable})`,
              // label: `${brand.productName}`
            });
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getProducts = (brandId, token) => {
  return new Promise((resolve, reject) => {
    api.products
      .getProducts({ brandId }, token)
      .then((res) => {
        let parsedResult = [];
        if (res.code === 200 && res.data.result) {
          res.data.result.forEach((brand) => {
            // Use forEach instead of map
            parsedResult.push({
              ...brand,
              margin: brand.productMargin,
              value: brand.productId,
              label: brand.isEpay
                ? brand.productName
                : `${brand.productName} (Available stock Qty - ${brand.stockAvailable})`,
            });
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getBrands = (id, token) => {
  return new Promise((resolve, reject) => {
    api.brands
      .getBrands({}, token)
      .then((res) => {
        let parsedResult = [];
        if (res.data.result) {
          res.data.result.map((brand) => {
            parsedResult.push({
              value: brand.brandId,
              label: brand.brandName,
            });
            return null;
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

// export const getBrands = ({}, token) => {
//     return new Promise((resolve, reject) => {
//         api.brands.getBrands({}, token).then(res => {
//             let parsedResult = [];
//             if (res.data.result) {
//                 parsedResult = res.data.result.map(brand => ({
//                     value: brand.brandId,
//                     label: brand.brandName
//                 }));
//             }
//             resolve(parsedResult);
//         }).catch(err => {
//             resolve([]);
//         });
//     });
// };

export const getGenbaProductPriceList = (sku, token) => {
  return new Promise((resolve, reject) => {
    api.products
      .getGenbaProductPrice({ sku }, token)
      .then((resp) => {
        let parsedResult = [];
        resp.Prices.map((price) => {
          parsedResult.push({
            value: price.Product,
            label: price.Product,
            currencycode: price.CurrencyCode,
            srp: price.Srp,
            wsp: price.Wsp,
            sku: price.Sku,
          });
          return null;
        });
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getMasterProductsList = (brandId, token) => {
  return new Promise((resolve, reject) => {
    api.products
      .getMasterData({ brandId }, token)
      .then((res) => {
        let parsedResult = [];
        if (res.code === 200 && res.data.result) {
          res.data.result.map((brand) => {
            parsedResult.push({
              value: brand.masterProdId,
              label: brand.masterProdName,
            });
            return null;
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getEzPinProductsList = (data, token) => {
  return new Promise((resolve, reject) => {
    api.products
      .getEzPinProducts(data, token)
      .then((resp) => {
        let parsedResult = [];
        resp.results.map((dt) => {
          parsedResult.push({
            value: `${dt.title}_${dt.currency.code} ${dt.max_price}`,
            label: `${dt.title}_${dt.currency.code} ${dt.max_price}`,
            sku: dt.sku,
            min_price: dt.min_price,
            max_price: dt.max_price,
            currency: dt.currency.code,
          });
          return null;
        });
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getGenbaProductsList = (data, token) => {
  return new Promise((resolve, reject) => {
    // api.products.getGenbaProducts(data,token).then(resp => {
    //     let parsedResult = []
    //     resp.Products.map(dt => {
    //         parsedResult.push({
    //             value: dt.Name,
    //             label: dt.Name,
    //             sku: dt.Sku,

    //         })
    //         return null;
    //     })
    //     resolve(parsedResult)
    // }).catch(err => {
    //     resolve([]);
    // })
    resolve([]);
  });
};

export const getAppIdForGenbaProductName = (name, token) => {
  return new Promise((resolve, reject) => {
    // api.products.getAppIdForGenbaProduct({name},token).then(res => {
    //     console.log(res, "steam ID");
    //     let parsedResult = [];
    //     // if (res.code === 200 && res) {
    //         // res.map(genba => {
    //             parsedResult.push({
    //                 value: res.app_id,
    //                 // label: genba.app_id,
    //             })
    //         // })
    //         console.log(parsedResult, "required data")
    //     // }
    //     resolve(parsedResult)
    // }).catch(err => {
    //     resolve([]);
    // })

    resolve([]);
  });
};

export const getMerchants = (status, token) => {
  return new Promise((resolve, reject) => {
    const data = {
      pageNo: 1,
      pageSize: 1000,
      thirdParty: status,
    };
    api.merchants
      .getMerchentList(data, token)
      .then((res) => {
        let parsedResult = [];
        if (res.data.result) {
          res.data.result.forEach((merchant) => {
            parsedResult.push({
              value: merchant.merchentId,
              label: merchant.merchentName,
            });
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getMerchantProducts = (merchantId, token) => {
  return new Promise((resolve, reject) => {
    api.products
      .getMasterProductsByMerchantId({ merchantId }, token)
      .then((res) => {
        let parsedResult = [];
        if (res.data) {
          res.data.forEach((prod) => {
            parsedResult.push({
              value: prod.masterProductId,
              label: prod.masterProductName,
            });
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};

export const getRegionList = (id, token) => {
  return new Promise((resolve, reject) => {
    api.resellerType
      .getResellerTypeList({}, token)
      .then((res) => {
        let parsedResult = [];
        if (res.data) {
          res.data.map((region) => {
            parsedResult.push({
              value: region.id,
              label: `${region.name} (${region.currency})`,
            });
            return null;
          });
        }
        resolve(parsedResult);
      })
      .catch((err) => {
        resolve([]);
      });
  });
};
